export default __webpack_public_path__ + "static/StackOfLovelyStreamrTokens-c287088d3bf20c5911264d233e013002.png";